import React from 'react';

const CircleInfoIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.33301 7.99992C1.33301 4.31802 4.31778 1.33325 7.99967 1.33325C11.6816 1.33325 14.6663 4.31802 14.6663 7.99992C14.6663 11.6818 11.6816 14.6666 7.99967 14.6666C4.31778 14.6666 1.33301 11.6818 1.33301 7.99992ZM12.991 5.93112C12.1541 3.91338 10.1841 2.59857 7.99967 2.59992C5.01864 2.60176 2.60301 5.01888 2.60301 7.99992C2.60301 10.1843 3.91904 12.1536 5.93729 12.9892C7.95554 13.8248 10.2784 13.3622 11.8226 11.8171C13.3667 10.272 13.8279 7.94885 12.991 5.93112ZM8.66634 4.66659V8.66658H7.33301V4.66659H8.66634ZM7.33301 9.99992V11.3333H8.66634V9.99992H7.33301Z"
        fill="#C40000"
      />
    </svg>
  );
};

export default CircleInfoIcon;
